import React, { useState, useEffect } from 'react';
import { f7, Page, Link, Button, Icon , Input } from 'framework7-react';
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from '../globals';

const AccountEditPage = () => {
  const [data, setData] = useState({});
  
  // useEffect(() => {
  //   axios.get(API_BASE_URL + 'contactpreference', {
  //       headers: {
  //         'Authorization': 'Basic ' + API_AUTH
  //       },
  //       params: {
  //         id: localStorage.getItem('id'),
  //         limits: 1
  //       }
  //     })
  //     .then(response => setData(response.data[0]))
  //     .catch(error => console.log(error));
  // }, []);s
  
  const handleSubmit = (e) => {
    e.preventDefault();
    axios.put(API_BASE_URL + 'v1/accountdeletion/id/'+localStorage.getItem('id'), data, {
      headers: {
        'Authorization': 'Basic ' + API_AUTH
      }
    })

    .then((response) => {
      // Clear local storage
      localStorage.clear();
      
      // Navigate to login page
      f7.views.main.router.navigate('/login/');
      f7.dialog.alert('Account got deleted');

      // f7.views.main.router.navigate('/login/', {
      //   reloadAll: true
      // });
      // f7.tab.show('#tab-3');
      // f7.toast
      //   .create({
      //     text: 'Event Cancelled ..!',
      //     position: 'top',
      //     cssClass: 'bg-color-red',
      //     closeTimeout: 2000,
      //   })
      //   .open();        
    })
    .catch((error) => f7.dialog.alert('Error updating data!'));

      // .then(response => f7.toast.create({
      //   text: 'Account got deleted..!',
      //   position: 'top',
      //   cssClass: 'bg-color-teal',
      //   closeTimeout: 2000
      // }).open())

      // // localStorage.clear();      
      // // f7.views.main.router.navigate('/login/');

      // .catch(error => f7.toast.create({
      //   text: 'Account got deleted..!',
      //   position: 'top',
      //   cssClass: 'bg-color-teal',
      //   closeTimeout: 2000
      // }).open());
  }
  return (
    <Page className='bg-white'>
      {/* <Navbar title="Restaurant Information" backLink="Back" noShadow/>             */}
      <div className="container container-table  ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
                <h2>Account Deletion</h2>
              </div>
            </div>
          </header>
          <section className="section-b-space">
            <div className="custom-container p-0">
              <form onSubmit={handleSubmit} className="auth-form profile-form">
                <div className="form-group">
                  <label className="form-label fw-semibold">Deletion type</label>
                  <div className="form-input mb-4">
                    <select className="form-select form-control" value={data.status} validate required placeholder="Please choose..." onChange={(event) => setData({...data, status: event.target.value})}>
                      <option value="0">Select</option>
                      <option value="3">Deactivate Account</option>
                      <option value="4">Delete Account</option>
                    </select>
                  </div>
                </div>
                <Button type="submit" fill large className="btn btn-danger save-address w-100 mt-0">
                  Delete
                </Button>
              </form>
            </div>
          </section>
      </div>
    </div>
    </Page>
  );
}
export default AccountEditPage;
